import React from 'react';
import { Eye } from 'lucide-react';
import ShopThemed from '../../themes';

// ===== Live phone preview — renders the shop's chosen theme =====
export const LivePreview = ({ form, barbers, services, hours }) => {
  // Compose a shop-shaped object from the live form (so unsaved edits show).
  const previewShop = {
    name: form.name || 'Your shop',
    tagline: form.tagline,
    welcome_text: form.welcome_text,
    address: form.address,
    address_line_1: form.address_line_1,
    address_line_2: form.address_line_2,
    city: form.city,
    postcode: form.postcode,
    logo_url: form.logo_url,
    accent_colour: form.accent_colour,
    gallery_urls: form.gallery_urls,
    hero_image_url: form.hero_image_url,
    hero_opacity: form.hero_opacity,
    reviews: form.reviews,
    deposit_required: form.deposit_required,
    deposit_amount: form.deposit_amount,
    social_links: form.social_links || {},
    theme: form.theme,
  };

  return (
    <div className="preview">
      <div className="ttl"><Eye size={14} /> Live preview</div>
      <div className="pframe">
        <div className="pscreen pscreen-themed">
          <div className="themed-preview-scaler">
            <ShopThemed
              theme={form.theme}
              shop={previewShop}
              services={services}
              barbers={barbers}
              hours={hours}
              showHours={form.show_hours !== false}
              onBook={() => {}}
            />
          </div>
        </div>
      </div>
      <div className="pv-foot-note">
        Updates as you edit. Customers<br />see this on their phone.
      </div>
    </div>
  );
};
